export type HotelFileKind = "logo" | "map";

export type FileUploadOutcome =
  | { ok: true; fileId: string }
  | { ok: false; error: unknown };

/** Thrown when a hotel file (logo/map) fails to upload; the hotel must not be saved. */
export class HotelFileUploadError extends Error {
  readonly kind: HotelFileKind;
  readonly cause: unknown;

  constructor(kind: HotelFileKind, cause: unknown) {
    super(`Failed to upload hotel ${kind} file`);
    this.name = "HotelFileUploadError";
    this.kind = kind;
    this.cause = cause;
  }
}

/**
 * Picks the file id to save with the hotel. A failed upload throws instead of
 * falling back to the current id, so the hotel is never saved (and success never
 * shown) when the user's new file was lost.
 */
export const resolveUploadedFileId = (
  kind: HotelFileKind,
  outcome: FileUploadOutcome,
): string => {
  if (!outcome.ok) {
    throw new HotelFileUploadError(kind, outcome.error);
  }
  return outcome.fileId;
};

export const getHotelSaveErrorKey = (error: unknown): string => {
  if (error instanceof HotelFileUploadError) {
    return error.kind === "map"
      ? "hotels.form.failedToUploadMap"
      : "hotels.form.failedToUploadLogo";
  }
  return "hotels.form.failedToUpdateHotel";
};
